/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{827B2DC1-FFE8-401C-BCF6-3266DC931425}",
  "sitecoreApiHost": "https://www.v2.wemshowcase.com",
  "jssAppName": "JssReactWeb",
  "applicationInsights": "b1f19bb1-4508-49d4-afe0-d90257b2a9a3",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/jssreactweb",
  "graphQLEndpoint": "https://www.v2.wemshowcase.com/api/jssreactweb?sc_apikey={827B2DC1-FFE8-401C-BCF6-3266DC931425}"
};